import { render, staticRenderFns } from "./cardTemplateVip20.vue?vue&type=template&id=e7542404&scoped=true&"
import script from "./cardTemplateVip20.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip20.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip20.vue?vue&type=style&index=0&id=e7542404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7542404",
  null
  
)

export default component.exports